import { CliMatch } from "@types";
import { makeResultKey } from "@utils";

import { Highlight } from "@pages/editor/types";

import { makeMatchHighlight } from "./makeMatchHighlight";

export const applyFix = (
  r: CliMatch,
  target: string,
  highlighted: readonly Highlight[]
): { newTarget: string; newHighlights: readonly Highlight[] } => {
  // get the start and end points
  const lines = target.split("\n");
  if (r.extra.fixed_lines && lines.length > 0) {
    const startLine = (r.start.line || 1) - 1; // start.line is 1 indexed
    const endLine = (r.end.line || 1) - 1; // end.line is 1 indexed
    // break into before, to modify, after
    const beforeLines = lines.slice(0, startLine);
    const afterLines = lines.slice(endLine + 1); // next line after end of match
    const modifiedLines = r.extra.fixed_lines;
    // build new string
    const contentsAfterfix = [...beforeLines, ...modifiedLines, ...afterLines];
    const newEndLine = startLine + r.extra.fixed_lines.length;
    const startCol = (r.start.col || 1) - 1; // start.col is 1 indexed
    const newEndCol =
      startCol + 1 + r.extra.fixed_lines[r.extra.fixed_lines.length - 1].length; // TODO
    const newTarget = contentsAfterfix.join("\n");
    // TODO update highlights
    const key = makeResultKey(r);
    const otherHighlights = highlighted.filter((hl) => hl.key !== key);
    const newHighlights = [
      ...otherHighlights,
      makeMatchHighlight(r, { line: newEndLine, col: newEndCol }),
    ];
    return { newTarget, newHighlights };
  } else {
    console.warn("problem applying fixed lines", r.extra.fixed_lines, target);
    return { newTarget: target, newHighlights: highlighted };
  }
};
